import { DigitalFormsTypes } from '@frontend/api-digital-forms';
import {
  DEFAULT_SUBMISSIONS_DATE_FILTER,
  DEFAULT_SUBMISSIONS_SORT_ORDER,
} from '../../../../submission-list-view.constants';
import { SubmissionDateFilter } from '../../../../submission-list-view.types';
import { SubmissionV2ListViewState } from '../../store.type';

interface UpdateSubmissionsSearchValuePayload {
  submissionsSearchValue: string;
}

type UpdateSubmissionsSearchValueResults = Pick<
  SubmissionV2ListViewState,
  | 'isSelectAllActive'
  | 'isSelectAllIndeterminate'
  | 'selectedSubmissions'
  | 'selectedSubmissionIdsMap'
  | 'submissionsSearchValue'
>;

export function updateSearchValue({
  submissionsSearchValue,
}: UpdateSubmissionsSearchValuePayload): UpdateSubmissionsSearchValueResults {
  return {
    isSelectAllActive: false,
    isSelectAllIndeterminate: false,
    selectedSubmissions: [],
    selectedSubmissionIdsMap: {},
    submissionsSearchValue,
  };
}

interface UpdateSubmissionsFilterPayload {
  dateFilter?: SubmissionDateFilter;
  sortOrder?: DigitalFormsTypes.SchemaMessages.Order;
}

type UpdateSubmissionsFilterResults = Pick<
  SubmissionV2ListViewState,
  | 'isSelectAllActive'
  | 'isSelectAllIndeterminate'
  | 'selectedSubmissions'
  | 'selectedSubmissionIdsMap'
  | 'dateFilterForSubmissions'
  | 'sortOrderForSubmissions'
>;

export function updateSubmissionsFilter({
  dateFilter,
  sortOrder,
}: UpdateSubmissionsFilterPayload): UpdateSubmissionsFilterResults {
  return {
    isSelectAllActive: false,
    isSelectAllIndeterminate: false,
    selectedSubmissions: [],
    selectedSubmissionIdsMap: {},
    dateFilterForSubmissions: dateFilter || DEFAULT_SUBMISSIONS_DATE_FILTER,
    sortOrderForSubmissions: sortOrder || DEFAULT_SUBMISSIONS_SORT_ORDER,
  };
}
